import BaseMessageRecord from "../BaseMessageRecord";
import { httpMessageRecordDefaultAttributes, getInvalidHttpFields } from "../HTTPMessageRecord";

class SalesforceMessageRecord extends BaseMessageRecord({
  ...httpMessageRecordDefaultAttributes,
  displayType: "salesforce",
  requestType: "POST"
}) {}

SalesforceMessageRecord.getInvalidFields = getInvalidHttpFields;

export default SalesforceMessageRecord;
